import{isArray as r}from"./isArray.js";function o(o){return!r(o)&&o-parseFloat(o)+1>=0}export{o as isNumeric};
